module.exports = __webpack_public_path__ + "media/react/assets/images/full-logo-94af19068e956aa7fb37bdf9d66f6268.png";